import React, {useEffect} from "react";
import {Button, Form, Input, DatePicker, Select, Row, Col} from "antd";
import {useModel} from "../../../models";

const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 24,
    },
};
const {RangePicker} = DatePicker;

const rangeConfig = {
    rules: [{type: 'array', required: false, message: '请选择制单日期!'}],
};

export default function () {
    const [form] = Form.useForm();

    const [
        {saleStatusDict, invoiceTypeDict, customerDict, saleOrderTypeDict},
    ] = useModel("cmDict");

    const [
        {searchParam, documentPageInfo},
        {setSearchParam, loadDocumentList}
    ] = useModel("saleSo");

    /*useEffect(() => {
        const {startEndDate} = searchParam;
        const transDate = !!startEndDate && startEndDate.length === 2 ? [moment(startEndDate[0]), moment(startEndDate[1])] : null;
        form.setFieldsValue({
            ...searchParam,
            startEndDate: transDate
        });
    }, []);*/

    useEffect(() => {
        form.setFieldsValue(searchParam);
    }, [searchParam]);


    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
        const {pageSize, pageNum} = documentPageInfo;
        const {saleCode, customerId, orderStatus, invoiceType,orderType,createUser} = searchParam;
        // console.log(orderStatus)
        let data = {
            pageSize,
            pageNum,
            startTime,
            endTime,
            saleCode,
            customerId,
            orderStatus:orderStatus?orderStatus.toString():"",
            invoiceType,
            orderType,
            createUser
        };
        loadDocumentList({showMsg: true, data});
    }
    const onReset = () => {
        form.resetFields();
        setSearchParam({});
        loadDocumentList({showMsg: true, data: {pageSize: 15, pageNum: 1}});
    }

    return (
        <Form
            form={form}
            name="sale_so_search_form"
            labelCol={{span: 6}}
            onFinish={onFinish}
            onValuesChange={e => {
                // let orderStatus = ""
                // if(e.orderStatus.length!=0){
                //     // console.log(e.orderStatus.toString())
                //     // console.log(e)
                //     orderStatus = e.orderStatus.toString()
                // }
                setSearchParam({...searchParam, ...e})
            }}
        >
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="saleCode"
                        label="销售单号"
                    >
                        <Input placeholder="销售单号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerId"
                        label="客户名称"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择客户"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={customerDict}
                            dropdownClassName="dark-select"
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="orderStatus"
                        label="状态"
                    >
                        <Select
                            showSearch
                            mode="multiple"
                            allowClear={true}
                            placeholder="选择状态"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={saleStatusDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="invoiceType"
                        label="发票类型"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择发票类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={invoiceTypeDict}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="orderType"
                        label="销售类型"
                        style={{marginBottom: 0}}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择销售类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={saleOrderTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="createUser"
                        label="业务员"
                        style={{marginBottom: 0}}
                    >
                        <Input placeholder="业务员"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="startEndDate"
                        style={{marginBottom: 0}}
                        label="制单日期" {...rangeConfig}
                    >
                        <RangePicker style={{width: "100%"}}/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        shouldUpdate={true}
                        style={{marginBottom: 0}}
                        {...tailLayout}
                    >
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="button"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>

                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}